;(() => {
  let lastFocusedElement
  let scrollY = 0;

  const openPopup = (popup) => {
    if (!popup) return
    lastFocusedElement = document.activeElement
    scrollY = window.scrollY;
    document.body.style.position = 'fixed';
    document.body.style.top = `-${scrollY}px`;
    document.body.style.left = '0';
    document.body.style.right = '0';
    popup.classList.add('s-active')
    popup.setAttribute('aria-hidden', 'false')

    const focusTarget = popup.querySelector(
      '[data-popup-close], button, [href], input, select, textarea'
    )
    if (focusTarget) {
      focusTarget.focus()
    }

    popup.addEventListener('keydown', handleFocusTrap)
  }

  const closePopup = (popup) => {
    if (!popup) return
    popup.classList.remove('s-active')
    popup.setAttribute('aria-hidden', 'true')
    popup.removeEventListener('keydown', handleFocusTrap)
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    window.scrollTo(0, scrollY);

    if (lastFocusedElement) {
      lastFocusedElement.focus()
    }
  }

  const handleFocusTrap = (event) => {
    if (event.key !== 'Tab') return
    const popup = event.currentTarget
    const focusableElements = Array.from(
      popup.querySelectorAll(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      )
    ).filter((el) => !el.closest('[disabled]') && el.offsetParent !== null)

    if (focusableElements.length === 0) return
    const firstElement = focusableElements[0]
    const lastElement = focusableElements[focusableElements.length - 1]

    if (event.shiftKey) {
      if (document.activeElement === firstElement) {
        lastElement.focus()
        event.preventDefault()
      }
    } else {
      if (document.activeElement === lastElement) {
        firstElement.focus()
        event.preventDefault()
      }
    }
  }

  const initPopups = () => {
    document.querySelectorAll('[data-popup-open]').forEach((trigger) => {
      const popupId = trigger.dataset.popupOpen
      const popup = document.getElementById(popupId)
      trigger.addEventListener('click', () => openPopup(popup))
    })

    document.querySelectorAll('[data-popup-close]').forEach((trigger) => {
      const popup = trigger.closest('[data-popup]')
      if (popup) {
        trigger.addEventListener('click', () => closePopup(popup))
      }
    })

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        const activePopup = document.querySelector('[data-popup].s-active')
        if (activePopup) {
          closePopup(activePopup)
        }
      }
    })
  }

  document.addEventListener('DOMContentLoaded', initPopups)
})()
